export type TelegramRuntime = {
  tg: any | null;
  init: () => void;
};

function isMobilePlatform(platform: string) {
  return platform === 'android' || platform === 'ios';
}

function isWebPlatform(platform: string) {
  return platform === 'web' || platform === 'weba';
}

export function createTelegramRuntime(): TelegramRuntime {
  const tg = (window as any).Telegram?.WebApp ?? null;

  function init() {
    if (!tg) return;

    try { tg.ready?.(); } catch {}
    try { tg.disableVerticalSwipes?.(); } catch {}

    // Cache initData for \"second open\" stability (legacy behavior from telegram-init.js)
    try {
      const initData = tg.initData;
      if (initData && typeof initData === 'string' && initData.length > 0) {
        localStorage.setItem('telegramInitDataCache', initData);
        localStorage.setItem('telegramInitDataTimestamp', Date.now().toString());
      }
    } catch {}

    // Cache Telegram user (fallback when initDataUnsafe is temporarily empty)
    try {
      const user = tg.initDataUnsafe?.user;
      if (user?.id) {
        localStorage.setItem('telegramUserCache', JSON.stringify(user));
        localStorage.setItem('telegramUserTimestamp', Date.now().toString());
      }
    } catch {}

    // Theme: avoid hardcoded colors; use themeParams when available.
    try {
      const bgColor = tg.themeParams?.bg_color || '#000000';
      const headerColor = tg.themeParams?.secondary_bg_color || bgColor;
      tg.setHeaderColor?.(headerColor);
      tg.setBackgroundColor?.(bgColor);
    } catch {}

    // Fullscreen best-effort (mostly affects Android).
    try {
      const platform = String(tg.platform || '');
      if (isWebPlatform(platform) || !isMobilePlatform(platform)) return;

      tg.expand?.();
      if (typeof tg.requestFullscreen !== 'function') return;

      let requested = false;
      const tryFs = () => {
        if (requested) return;
        requested = true;
        try { tg.requestFullscreen(); } catch { /* best-effort */ }
      };

      setTimeout(tryFs, 120);
      const onFirstGesture = () => {
        requested = false;
        tryFs();
        document.removeEventListener('pointerdown', onFirstGesture, true);
      };
      document.addEventListener('pointerdown', onFirstGesture, { capture: true, passive: true });
    } catch {}
  }

  return { tg, init };
}


